<app-header></app-header>
<app-sidebar
  ativo="Comunicacao"
></app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <app-breadcrumb
      Titulo="WhatsApp"
      [TemPaginaPai] = true
      PaginaPai="Comunicação"
      Pagina="WhatsApp"
    ></app-breadcrumb>

    <div class="content p-0">
      <div class="d-md-flex">
        <!-- Contacts sidebar -->
        <div class="whatsapp-sidebar border-end border-bottom bg-white w-100 simplebar-scrollable-y" data-simplebar="init" style="max-width: 350px;">
          <div class="simplebar-wrapper">
            <div class="simplebar-height-auto-observer-wrapper">
              <div class="simplebar-height-auto-observer"></div>
            </div>
            <div class="simplebar-mask">
              <div class="simplebar-offset">
                <div class="simplebar-content-wrapper" tabindex="0" role="region" aria-label="scrollable content">
                  <div class="simplebar-content">
                    <div class="p-3">
                      <div class="border bg-light rounded p-2 mb-3">
                        <div class="input-group">
                          <input type="text" class="form-control border-0 bg-transparent" placeholder="Pesquisar contatos...">
                          <span class="input-group-text bg-transparent border-0"><i class="fa fa-search"></i></span>
                        </div>
                      </div>

                      <!-- Contacts list -->
                      <div class="mt-3">
                        <h5 class="mb-2">Conversas</h5>
                        <div class="contacts-list">
                          <div *ngFor="let contact of contacts"
                               class="contact-item d-flex align-items-center p-2 rounded mb-2"
                               [class.active]="selectedContact?.id === contact.id"
                               [class.unread]="contact.unreadCount > 0"
                               (click)="selectContact(contact)">
                            <div class="position-relative">
                              <div class="fundo-iniciais">{{ buscarIniciais(contact.name) }}</div>
                              <span *ngIf="contact.unreadCount > 0" class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                {{ contact.unreadCount }}
                              </span>
                            </div>
                            <div class="ms-2 flex-grow-1">
                              <div class="d-flex justify-content-between align-items-center">
                                <h6 class="mb-0 fw-medium">{{ contact.name }}</h6>
                                <small class="text-muted">{{ formatDate(contact.lastMessageTime!) }}</small>
                              </div>
                              <p class="mb-0 text-truncate" style="max-width: 200px;">{{ contact.lastMessage }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="simplebar-placeholder"></div>
          </div>
          <div class="simplebar-track simplebar-horizontal" style="visibility: hidden;">
            <div class="simplebar-scrollbar" style="width: 0px; display: none;"></div>
          </div>
          <div class="simplebar-track simplebar-vertical" style="visibility: visible;">
            <div class="simplebar-scrollbar" style="height: 552px; transform: translate3d(0px, 0px, 0px); display: block;"></div>
          </div>
        </div>

        <!-- Conversation area -->
        <div class="conversation-area bg-white border-bottom w-100 d-flex flex-column" style="height: calc(100vh - 200px);" *ngIf="selectedContact && selectedConversation">
          <!-- Conversation header -->
          <div class="conversation-header p-3 border-bottom d-flex align-items-center">
            <div class="fundo-iniciais">{{ buscarIniciais(selectedContact.name) }}</div>
            <div class="ms-2">
              <h6 class="mb-0 fw-medium">{{ selectedContact.name }}</h6>
              <small class="text-muted">{{ selectedContact.phone }}</small>
            </div>
          </div>

          <!-- Messages area -->
          <div class="messages-container p-3 flex-grow-1 overflow-auto">
            <div *ngFor="let message of selectedConversation.messages"
                 class="message mb-3"
                 [class.outgoing]="!message.isIncoming"
                 [class.incoming]="message.isIncoming">
              <div class="message-bubble p-2 rounded">
                <p class="mb-0">{{ message.text }}</p>
                <small class="text-muted d-block text-end">{{ message.timestamp | date:'HH:mm' }}</small>
              </div>
            </div>
          </div>

          <!-- Message input area -->
          <div class="message-input-area p-3 border-top">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Digite uma mensagem..." [(ngModel)]="newMessage">
              <button class="btn btn-primary" type="button" (click)="sendMessage()">
                <i class="fa fa-paper-plane"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Empty state when no conversation is selected -->
        <div class="conversation-area bg-white border-bottom w-100 d-flex flex-column justify-content-center align-items-center"
             style="height: calc(100vh - 200px);"
             *ngIf="!selectedContact || !selectedConversation">
          <div class="text-center p-4">
            <i class="fa fa-comments fa-4x text-muted mb-3"></i>
            <h4>Selecione uma conversa para começar</h4>
            <p class="text-muted">Escolha um contato da lista para ver as mensagens</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
